/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from '../shared/assets/css/inline-edit-common.scss.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '@angular/forms';
import * as i3 from '@angular/common';
import * as i4 from '../../../../../../../../src/app/components/shared/inline-edit/components/input-number/input-number.component';
const styles_InputNumberComponent:any[] = [i0.styles];
export const RenderType_InputNumberComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,
    styles:styles_InputNumberComponent,data:{}});
function View_InputNumberComponent_1(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),6,'p',[['class',
      'alert alert-danger flat-elm font-14']],(null as any),(null as any),(null as any),
      (null as any),(null as any))),(_l()(),i1.ɵted((null as any),['\n	'])),(_l()(),
      i1.ɵeld(0,(null as any),(null as any),3,'strong',([] as any[]),(null as any),
          (null as any),(null as any),(null as any),(null as any))),(_l()(),i1.ɵted((null as any),
      ['\n		'])),(_l()(),i1.ɵeld(0,(null as any),(null as any),0,'i',[['aria-hidden',
      'true'],['class','fa fa-exclamation-circle']],(null as any),(null as any),(null as any),
      (null as any),(null as any))),(_l()(),i1.ɵted((null as any),['\n	'])),(_l()(),
      i1.ɵted((null as any),[' ','\n']))],(null as any),(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = _co.vError;
    _ck(_v,6,0,currVal_0);
  });
}
function View_InputNumberComponent_2(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),18,'div',[['class',
      'input-group']],(null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵted((null as any),['\n	'])),(_l()(),i1.ɵeld(0,(null as any),(null as any),
          6,'input',[['class','form-control'],['min','0'],['type','number']],[[8,'placeholder',
              0],[2,'ng-untouched',(null as any)],[2,'ng-touched',(null as any)],[2,
              'ng-pristine',(null as any)],[2,'ng-dirty',(null as any)],[2,'ng-valid',
              (null as any)],[2,'ng-invalid',(null as any)],[2,'ng-pending',(null as any)]],
          [[(null as any),'ngModelChange'],[(null as any),'input'],[(null as any),
              'blur'],[(null as any),'compositionstart'],[(null as any),'compositionend'],
              [(null as any),'change']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:any = _v.component;
            if (('input' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,3)._handleInput($event.target.value)) !== false);
              ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
              const pd_1:any = ((<any>i1.ɵnov(_v,3).onTouched()) !== false);
              ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
              const pd_2:any = ((<any>i1.ɵnov(_v,3)._compositionStart()) !== false);
              ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
              const pd_3:any = ((<any>i1.ɵnov(_v,3)._compositionEnd($event.target.value)) !== false);
              ad = (pd_3 && ad);
            }
            if (('change' === en)) {
              const pd_4:any = ((<any>i1.ɵnov(_v,4).onChange($event.target.value)) !== false);
              ad = (pd_4 && ad);
            }
            if (('input' === en)) {
              const pd_5:any = ((<any>i1.ɵnov(_v,4).onChange($event.target.value)) !== false);
              ad = (pd_5 && ad);
            }
            if (('blur' === en)) {
              const pd_6:any = ((<any>i1.ɵnov(_v,4).onTouched()) !== false);
              ad = (pd_6 && ad);
            }
            if (('ngModelChange' === en)) {
              const pd_7:any = ((<any>(_co.localData = $event)) !== false);
              ad = (pd_7 && ad);
            }
            return ad;
          },(null as any),(null as any))),i1.ɵdid(16384,(null as any),0,i2.DefaultValueAccessor,
          [i1.Renderer2,i1.ElementRef,[2,i2.COMPOSITION_BUFFER_MODE]],(null as any),
          (null as any)),i1.ɵdid(16384,(null as any),0,i2.ɵbc,[i1.Renderer2,i1.ElementRef],
          (null as any),(null as any)),i1.ɵprd(1024,(null as any),i2.NG_VALUE_ACCESSOR,
          (p0_0:any,p1_0:any) => {
            return [p0_0,p1_0];
          },[i2.DefaultValueAccessor,i2.ɵbc]),i1.ɵdid(671744,(null as any),0,i2.NgModel,
          [[8,(null as any)],[8,(null as any)],[8,(null as any)],[2,i2.NG_VALUE_ACCESSOR]],
          {model:[0,'model']},{update:'ngModelChange'}),i1.ɵprd(2048,(null as any),
          i2.NgControl,(null as any),[i2.NgModel]),i1.ɵdid(16384,(null as any),0,i2.NgControlStatus,
          [i2.NgControl],(null as any),(null as any)),(_l()(),i1.ɵted((null as any),
          ['\n	'])),(_l()(),i1.ɵeld(0,(null as any),(null as any),7,'span',[['class',
          'input-group-addon flat-elm']],(null as any),(null as any),(null as any),
          (null as any),(null as any))),(_l()(),i1.ɵted((null as any),['\n		'])),(_l()(),
          i1.ɵeld(0,(null as any),(null as any),1,'span',[['class','text-green cp text-bold m-right-10']],
              (null as any),[[(null as any),'click']],(_v,en,$event) => {
                var ad:boolean = true;
                var _co:any = _v.component;
                if (('click' === en)) {
                  const pd_0:any = ((<any>_co.onSaveClick()) !== false);
                  ad = (pd_0 && ad);
                }
                return ad;
              },(null as any),(null as any))),(_l()(),i1.ɵted((null as any),['Save'])),
      (_l()(),i1.ɵted((null as any),['\n		'])),(_l()(),i1.ɵeld(0,(null as any),(null as any),
          1,'span',[['class','text-red cp text-bold']],(null as any),[[(null as any),
              'click']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:any = _v.component;
            if (('click' === en)) {
              const pd_0:any = ((<any>_co.onCancelClick()) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },(null as any),(null as any))),(_l()(),i1.ɵted((null as any),['Cancel'])),
      (_l()(),i1.ɵted((null as any),['\n	'])),(_l()(),i1.ɵted((null as any),['\n']))],
      (_ck,_v) => {
        var _co:any = _v.component;
        const currVal_8:any = _co.localData;
        _ck(_v,6,0,currVal_8);
      },(_ck,_v) => {
        var _co:any = _v.component;
        const currVal_0:any = _co.placeholder;
        const currVal_1:any = i1.ɵnov(_v,8).ngClassUntouched;
        const currVal_2:any = i1.ɵnov(_v,8).ngClassTouched;
        const currVal_3:any = i1.ɵnov(_v,8).ngClassPristine;
        const currVal_4:any = i1.ɵnov(_v,8).ngClassDirty;
        const currVal_5:any = i1.ɵnov(_v,8).ngClassValid;
        const currVal_6:any = i1.ɵnov(_v,8).ngClassInvalid;
        const currVal_7:any = i1.ɵnov(_v,8).ngClassPending;
        _ck(_v,2,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6,
            currVal_7);
      });
}
export function View_InputNumberComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵand(16777216,(null as any),(null as any),1,(null as any),
      View_InputNumberComponent_1)),i1.ɵdid(16384,(null as any),0,i3.NgIf,[i1.ViewContainerRef,
      i1.TemplateRef],{ngIf:[0,'ngIf']},(null as any)),(_l()(),i1.ɵted((null as any),
      ['\n'])),(_l()(),i1.ɵand(16777216,(null as any),(null as any),1,(null as any),
      View_InputNumberComponent_2)),i1.ɵdid(16384,(null as any),0,i3.NgIf,[i1.ViewContainerRef,
      i1.TemplateRef],{ngIf:[0,'ngIf']},(null as any))],(_ck,_v) => {
    var _co:i4.InputNumberComponent = _v.component;
    const currVal_0:any = _co.vError;
    _ck(_v,1,0,currVal_0);
    const currVal_1:any = (_co.state === 'active');
    _ck(_v,4,0,currVal_1);
  },(null as any));
}
export function View_InputNumberComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),1,'inline-edit-input-number',
      ([] as any[]),(null as any),(null as any),(null as any),View_InputNumberComponent_0,
      RenderType_InputNumberComponent)),i1.ɵdid(638976,(null as any),0,i4.InputNumberComponent,
      ([] as any[]),(null as any),(null as any))],(_ck,_v) => {
    _ck(_v,1,0);
  },(null as any));
}
export const InputNumberComponentNgFactory:i1.ComponentFactory<i4.InputNumberComponent> = i1.ɵccf('inline-edit-input-number',
    i4.InputNumberComponent,View_InputNumberComponent_Host_0,{data:'data',fingerprint:'fingerprint',
        placeholder:'placeholder',required:'required',positiveValue:'positiveValue'},
    {onSave:'onSave',onCancel:'onCancel'},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// ./node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./compiled/src/app/components/shared/inline-edit/components/input-number/input-number.component.ngfactory.ts